// Nutra Gold Theme — Shared UI Behaviors
// Shopify Online Store 2.0 — ES Module

(function() {
  'use strict';

  // =============================================
  // 1. Drawer Toggle
  // =============================================
  class Drawer {
    constructor(element) {
      this.element = element;
      this.overlay = element.querySelector('[data-drawer-overlay]');
      this.closeTriggers = element.querySelectorAll('[data-drawer-close]');
      this.openTriggers = document.querySelectorAll(`[data-drawer-open="${element.id}"]`);
      this.body = document.body;

      this._init();
    }

    _init() {
      // Open triggers
      this.openTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      // Close triggers
      this.closeTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      });

      // Overlay click
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });
    }

    open() {
      this.element.classList.add('drawer--open');
      this.body.classList.add('drawer-open');
      this.isOpen = true;
    }

    close() {
      this.element.classList.remove('drawer--open');
      this.body.classList.remove('drawer-open');
      this.isOpen = false;
    }
  }

  // Initialize all drawers on DOM ready
  document.querySelectorAll('[data-drawer]').forEach(el => {
    new Drawer(el);
  });

  // =============================================
  // 2. Form Validation
  // =============================================
  const validators = {
    email: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
    required: (value) => value.trim().length > 0,
    phone: (value) => /^[\d\s()+-]{8,}$/.test(value),
  };

  function validateField(field) {
    const type = field.dataset.validate || field.type;
    const value = field.value;
    const errorElement = field.closest('.input-wrapper')?.querySelector('.input__error');

    let isValid = true;
    let errorMessage = '';

    if (field.required && !validators.required(value)) {
      isValid = false;
      errorMessage = 'Este campo é obrigatório';
    } else if (type === 'email' && value && !validators.email(value)) {
      isValid = false;
      errorMessage = 'Insira um e-mail válido';
    } else if (type === 'tel' && value && !validators.phone(value)) {
      isValid = false;
      errorMessage = 'Insira um telefone válido';
    }

    field.classList.toggle('input--error', !isValid);
    if (errorElement) {
      errorElement.textContent = errorMessage;
      errorElement.classList.toggle('input__error--visible', !isValid);
    }

    return isValid;
  }

  // Attach validation to forms with data-validate attribute
  document.querySelectorAll('form[data-validate]').forEach(form => {
    const fields = form.querySelectorAll('input, textarea, select');

    fields.forEach(field => {
      field.addEventListener('blur', () => validateField(field));
      field.addEventListener('input', () => {
        if (field.classList.contains('input--error')) {
          validateField(field);
        }
      });
    });

    form.addEventListener('submit', (e) => {
      let allValid = true;
      fields.forEach(field => {
        if (!validateField(field)) {
          allValid = false;
        }
      });
      if (!allValid) {
        e.preventDefault();
        const firstError = form.querySelector('.input--error');
        if (firstError) firstError.focus();
      }
    });
  });

  // =============================================
  // 3. Sticky Header
  // =============================================
  const header = document.querySelector('[data-sticky-header]');
  if (header) {
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll > header.offsetHeight) {
        if (currentScroll > lastScroll) {
          header.classList.add('header--hidden');
        } else {
          header.classList.remove('header--hidden');
        }
      } else {
        header.classList.remove('header--hidden');
      }

      header.classList.toggle('header--scrolled', currentScroll > 50);
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // =============================================
  // 4. DOM Ready Init
  // =============================================
  console.log('Nutra Gold Theme — UI behaviors initialized');
})();
